import type { EontyreEnv } from '@navio/nsdk';

/**
 * Adapter API environment (test|prod).
 * nsdk still names the wire type `EontyreEnv`.
 */
export type AdapterEnv = EontyreEnv;

export const asAdapterEnv = (value: string | null | undefined): AdapterEnv | null =>
  value === 'prod' || value === 'test' ? value : null;
